import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProgramsData } from "../../redux/slicer/academicSlice";
import parse, { domToReact } from "html-react-parser";
import Preloader from "../../assets/sab.jpeg";
import AcedamicsImg from "../../assets/Banners/Academics.jpg";
import { FaArrowLeft } from "react-icons/fa";

function ProgramDetails() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const programId = searchParams.get("id"); // Get program ID from URL

    const dispatch = useDispatch();
    const {
        data: programsData,
        loading: programsLoading,
        error: programsError,
    } = useSelector((state) => state.academic.programs);
    const [program, setProgram] = useState(null);

    useEffect(() => {
        dispatch(fetchProgramsData());
    }, [dispatch]);

    useEffect(() => {
        // Find the selected program when data is available
        if (programsData) {
            const selectedProgram = programsData.find(
                (p) => p.id === parseInt(programId)
            );
            setProgram(selectedProgram);
        }
    }, [programsData, programId]);

    // Scroll to the top of the page on component mount
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top
    }, []); // Empty dependency array ensures this runs only once on mount

    if (programsLoading) {
        return (
            <div className="flex items-center justify-center h-screen bg-white">
                <img
                    src={Preloader}
                    alt="Loading..."
                    className="w-24 h-24 sm:w-32 sm:h-32"
                />
            </div>
        );
    }

    if (programsError) {
        return <div className="text-red-600">Error: {programsError}</div>;
    }

    if (!program) {
        return <div>Program not found.</div>;
    }

    return (
        <div className="bg-gray-100 min-h-screen">
            {/* Banner Section */}
            <div className="relative max-w-full mx-auto">
                <div className="contain overflow-hidden w-full  h-[400px]">
                    <img
                        src={AcedamicsImg} // Use the imported image
                        alt="Program Details Banner"
                        className="w-full h-full object-cover object-center"
                    />
                    <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 text-center text-white">
                        <h2 className="text-4xl md:text-5xl  font-bold  font-titillium">
                            {parse(program.program_name)}
                        </h2>
                        <p className="text-lg mt-10 bg-img-description  font-titillium">
                          
                        </p>
                    </div>
                </div>
            </div>

            {/* Back Button */}
            <div className="container mx-auto mt-8 px-4 sm:px-6 lg:px-8">
                <Link
                    to="/acadamics" //  back to the Academics page
                    className="inline-flex items-center text-primary-color hover:text-secondary-color font-semibold"
                >
                    <FaArrowLeft className="mr-2" />
                    Back to Programs
                </Link>
            </div>

            {/* Program Details Section */}
            <div className="container mx-auto py-8 px-4 sm:px-6 lg:px-8">
                <div className="bg-white shadow overflow-hidden rounded-md">
                    <div className="p-6">
                        {/* Program Description */}
                        <h3 className="text-2xl font-semibold mb-4 text-gray-800">
                            Program Description
                        </h3>
                        <p className="text-gray-700 mb-6">
                            {parse(program.alumniNews_description)}
                        </p>

                        {/* Details Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* Admission Criteria */}
                            <div>
                                <h4 className="text-xl font-semibold mb-2 text-primary-color">
                                    Admission Criteria
                                </h4>
                                <ul className="list-disc pl-5 text-gray-700">
                                    {parse(program.eligibity_criteria, {
                                        replace: (domNode) => {
                                            if (domNode.name === "li") {
                                                return (
                                                    <li className="text-justify">
                                                        {domToReact(domNode.children)}
                                                    </li>
                                                );
                                            }
                                            if (domNode.name === "ul") {
                                                return (
                                                    <ul className="list-disc pl-6">
                                                        {domToReact(domNode.children)}
                                                    </ul>
                                                );
                                            }
                                        },
                                    })}
                                </ul>
                            </div>

                            {/* Program Benefits */}
                            <div>
                                <h4 className="text-xl font-semibold mb-2 text-primary-color">
                                    Programme Benefits
                                </h4>
                                <ul className="list-disc pl-5 text-gray-700">
                                    {parse(program.program_benefits, {
                                        replace: (domNode) => {
                                            if (domNode.name === "li") {
                                                return (
                                                    <li className="text-justify">
                                                        {domToReact(domNode.children)}
                                                    </li>
                                                );
                                            }
                                            if (domNode.name === "ul") {
                                                return (
                                                    <ul className="list-disc pl-6">
                                                        {domToReact(domNode.children)}
                                                    </ul>
                                                );
                                            }
                                        },
                                    })}
                                </ul>
                            </div>

                            {/* Eligibility Criteria */}
                            <div>
                                <h4 className="text-xl font-semibold mb-2 text-primary-color">
                                    Eligibility Criteria
                                </h4>
                                <ul className="list-disc pl-5 text-gray-700">
                                    {parse(program.eligibity_criteria, {
                                        replace: (domNode) => {
                                            if (domNode.name === "li") {
                                                return (
                                                    <li className="text-justify">
                                                        {domToReact(domNode.children)}
                                                    </li>
                                                );
                                            }
                                            if (domNode.name === "ul") {
                                                return (
                                                    <ul className="list-disc pl-6">
                                                        {domToReact(domNode.children)}
                                                    </ul>
                                                );
                                            }
                                        },
                                    })}
                                </ul>
                            </div>

                            {/* Supporting Documents */}
                            {program.files && program.files.length > 0 && (
                                <div>
                                    <h4 className="text-xl font-semibold mb-2 text-primary-color">
                                        Supporting Documents
                                    </h4>
                                    <ul className="list-disc pl-5 text-gray-700">
                                        {program.files.map((file, index) => (
                                            <li key={index}>
                                                <a
                                                    href={file}
                                                    download={file.name || `Document${index + 1}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-500 hover:underline"
                                                >
                                                    {file.name || `Document ${index + 1}`}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProgramDetails;